import config from 'utils/config';
export var isHelixEnabled = config.helixIntegrationMode === 'helix' || config.helixIntegrationMode === 'both';